import { PageDetectionUtil } from '~shared/utils/page-detection.util';

export type SkipLinksType = { id: string; label: string };
export type SkipToMenuMappersProp = { links: SkipLinksType[]; getPage: (s: string) => boolean }[];

export const skipToMenuMappers: SkipToMenuMappersProp = [
  {
    links: [
      {
        id: 'payment-method-container',
        label: 'GLOBAL.A11Y.SKIP_TO_MAIN_CONTENT',
      },
    ],
    getPage: PageDetectionUtil.isPaymentPage,
  },
  {
    links: [
      {
        id: 'thank-you-page_order-details-container',
        label: 'CHECKOUT.THANK_YOU.MESSAGE.ORDER_LINK',
      },
    ],
    getPage: PageDetectionUtil.isThankYouPage,
  },
  {
    links: [
      {
        id: 'review-order-container',
        label: 'GLOBAL.A11Y.SKIP_TO_MAIN_CONTENT',
      },
      {
        id: 'review-order_shipping-address',
        label: 'CHECKOUT.ADDRESS.SHIPPING.TITLE',
      },
      {
        id: 'review-order_billing-address',
        label: 'CHECKOUT.ADDRESS.BILLING.TITLE',
      },
      {
        id: 'review-order_phone-number',
        label: 'CHECKOUT.FREIGHT_FORWARDING.LABEL',
      },
      {
        id: 'review-order__payment-method',
        label: 'CHECKOUT.PAYMENT.TITLE',
      },
      {
        id: 'review-order_cart',
        label: 'CHECKOUT.CART.TITLE',
      },
      {
        id: 'review-page_totals',
        label: 'CHECKOUT.REVIEW.TOTAL',
      },
    ],
    getPage: PageDetectionUtil.isReviewPage,
  },
  {
    links: [
      {
        id: 'passwordless-signup-title',
        label: 'GLOBAL.A11Y.SKIP_TO_MAIN_CONTENT',
      },
    ],
    getPage: PageDetectionUtil.isPasswordlessSignup,
  },
  {
    links: [
      {
        id: 'blocked-title',
        label: 'GLOBAL.A11Y.SKIP_TO_MAIN_CONTENT',
      },
    ],
    getPage: PageDetectionUtil.isBlockedAccountPage,
  },
  {
    links: [
      {
        id: 'validate-email-title',
        label: 'GLOBAL.A11Y.SKIP_TO_MAIN_CONTENT',
      },
    ],
    getPage: PageDetectionUtil.isUserEmailValidationPage,
  },
];
